import React, { memo } from 'react';

import { Route, Routes } from 'react-router-dom';

import { FilterRouter } from 'components/FilterView';

import { AllowListTable } from './Components/AllowListTable';
import { CreateAllowList } from './Components/CreateAllowList';
import { EditAllowList } from './Components/EditAllowList';

interface Props {}

export const AllowList = memo((props: Props) => {
  return (
    <Routes>
      <Route element={<FilterRouter path="/inventory/allowlist/add" />}>
        <Route path="add" element={<CreateAllowList />} />
      </Route>
      <Route element={<FilterRouter path="/inventory/allowlist/edit/:uuid" />}>
        <Route path="edit/:uuid" element={<EditAllowList />} />
      </Route>
      {/* The list route checks the list permission, not the add one (copy-paste fix). */}
      <Route element={<FilterRouter path="/inventory/allowlist" />}>
        <Route index element={<AllowListTable />} />
      </Route>
    </Routes>
  );
});
